export default "__VITE_ASSET__C$Rxorj7__"